export const DESIGNATION_PLACEHOLDER = 'Product Designation'
export const SERVER_DESIGNATION_PLACEHOLDER = 'Insert Drawing Designation'
export const DESIGNATION_MAX_LENGTH = 50

export const DESIGNATION_UPDATE_SUCCESS_MESSAGE =
    'Drawing designation updated successfully'

export const DESIGNATION_SAVE_ERROR_MESSAGE =
    'Failed to save drawing designation'
export const DESIGNATION_MISSING_INFO_ERROR_MESSAGE =
    'Missing required information to save drawing designation'
